import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Eye, LogOut } from "lucide-react";

const ROLE_LABEL = { client: "Client", manager: "Manager" };

export default function ImpersonationBanner() {
  const { user, stopImpersonating } = useAuth();
  const navigate = useNavigate();
  if (!user || !user.impersonation?.active) return null;

  const exit = async () => {
    try {
      await stopImpersonating();
    } finally {
      navigate("/firm");
    }
  };

  return (
    <div
      className="flex items-center justify-center gap-3 bg-amber-500 px-4 py-2 text-sm font-medium text-amber-950"
      data-testid="impersonation-banner"
    >
      <Eye className="h-4 w-4 shrink-0" />
      <span className="truncate">
        Read-only view as <b>{user.name || user.email}</b>
        {ROLE_LABEL[user.role] ? ` · ${ROLE_LABEL[user.role]}` : ""}
        {user.impersonation.by_name ? ` — impersonated by ${user.impersonation.by_name}` : ""}
      </span>
      <button
        onClick={exit}
        data-testid="exit-impersonation-btn"
        className="ml-2 inline-flex shrink-0 items-center gap-1.5 rounded-full bg-amber-950/90 px-3 py-1 text-xs font-semibold text-amber-50 transition-colors hover:bg-amber-950"
      >
        <LogOut className="h-3.5 w-3.5" /> Exit view
      </button>
    </div>
  );
}
